<template>
  <div
    :class="c()"
  >
    <div v-html="html" />
    <a
      :href="href"
      :class="['btn btn__primary', c('button')]"
    >
      {{ textButton }}
    </a>
  </div>
</template>

<script>
import {cn} from '@/app/js/classname'

const c = cn('survey-finish')
export default {
  name: 'SurveyFinish',
  props: {
    html: {
      type: String,
      default: null
    },
    textButton: {
      type: String,
      default: 'Back to catalog'
    },
    href: {
      type: String,
      default: '/shop'
    }
  },
  methods: {
    c
  }
}
</script>

<style lang="scss">
.survey-finish {
  max-width: 660px;
  font-weight: 600;
  font-size: 16px;

  &__button {
    margin-top: 16px;
  }
}
</style>
